import React, { useState } from "react";
import { Carousel, CarouselItem, CarouselControl } from "reactstrap";
import { baseImageUrl } from "../../redux/base/types/url";

const Slidewithcontrol = ({
  items,
}: {
  items: {
    Id: string;
    Path: string;
  }[];
}) => {
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const [animating, setAnimating] = useState<boolean>(false);

  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  const slides = items.map((item) => {
    return (
      <CarouselItem
        onExiting={() => setAnimating(true)}
        onExited={() => setAnimating(false)}
        key={baseImageUrl + item.Path}
      >
        <img
          src={baseImageUrl + item.Path}
          className="d-block img-fluid"
          alt={baseImageUrl + item.Path}
        />
      </CarouselItem>
    );
  });

  return (
    <React.Fragment>
      <Carousel activeIndex={activeIndex} next={next} previous={previous}>
        {slides}
        <CarouselControl
          color="black"
          direction="prev"
          directionText="Previous"
          onClickHandler={previous}
        />
        <CarouselControl
          direction="next"
          color="black"
          directionText="Next"
          onClickHandler={next}
        />
      </Carousel>
    </React.Fragment>
  );
};

export default Slidewithcontrol;
